import { ILopBan } from "../../../model/respone/category/ILopBan";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eLopBanActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as ILopBan[],
  LOAD_ERRR: "",

  SHOW_EDIT_MODAL: {} as ILopBan | undefined,
  CLOSE_EDIT_MODAL: undefined,

  SAVE_START: {} as ILopBan,
  SAVE_SUCCESS: undefined,
  SAVE_ERRR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERRR: "",
};

export const eLopBanActionIds = generateActionTypeIds(eLopBanActionsObj, "LOP_BAN");
export type ILopBanActionTypes = IGenericActionType<typeof eLopBanActionsObj, "LOP_BAN">;
